import React from "react";
import { Helmet } from "react-helmet-async";
import { usePublicAuth } from "../context/PublicAuthContext";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";
import { Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";

export default function PublicLoginPage() {
  const { isPublicAuth, login, isPublicLoading } = usePublicAuth();
  const { user } = useAuth();
  const { settings } = useSettings();

  // Bereits eingeloggt → je nach Rolle weiterleiten
  if (isPublicAuth) {
    if (user?.role === "developer" || user?.role === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/profil" replace />;
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
      <Helmet>
        <title>Anmelden | HUWND</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="w-full max-w-md">
        {/* Logo aus Site-Settings */}
        <div className="text-center mb-10">
          {settings?.logo_url ? (
            <img
              src={settings.logo_url}
              alt={settings?.site_name || "HUWND"}
              className="h-12 w-auto mx-auto mb-4 object-contain"
            />
          ) : (
            <div className="w-14 h-14 bg-rose-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-black text-2xl font-heading">H</span>
            </div>
          )}
          {!settings?.logo_url && (
            <h1 className="text-3xl font-black text-white font-heading tracking-tight">
              {settings?.site_name || "HUWND"}
            </h1>
          )}
          <p className="text-zinc-500 text-sm mt-1">Hands Up Will Never Die</p>
        </div>

        <div className="bg-zinc-900 border border-white/5 rounded-2xl p-8 text-center space-y-6">
          <div>
            <h2 className="text-xl font-bold text-white mb-2">Anmelden</h2>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Kostenlos registrieren und Teil der HUWND Community werden.
              Releases liken, Artists folgen und mehr.
            </p>
          </div>

          <button
            onClick={() => login({ appState: { returnTo: "/profil" } })}
            disabled={isPublicLoading}
            data-testid="public-login-btn"
            className="w-full flex items-center justify-center gap-3 px-6 py-3.5 bg-rose-600 hover:bg-rose-700 disabled:opacity-50 text-white font-bold rounded-xl transition-colors text-sm"
          >
            <LogIn size={16} />
            {isPublicLoading ? "Laden..." : "Mit Google / Apple / E-Mail anmelden"}
          </button>

          <p className="text-zinc-600 text-xs">
            Mit der Registrierung stimmst du unseren{" "}
            <a href="/page/datenschutz" className="text-zinc-400 hover:text-white underline">
              Datenschutzbestimmungen
            </a>{" "}
            zu.
          </p>
        </div>

        <div className="text-center mt-6">
          <a href="/" className="text-zinc-600 hover:text-zinc-400 text-sm transition-colors">
            ← Zurück zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}
